import * as React from 'react';
const SvgCount = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 2.003a1 1 0 010-2h10a1 1 0 110 2H3zm9.5 1h-9a1.5 1.5 0 00-1.5 1.5v7a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-7a1.5 1.5 0 00-1.5-1.5zm-8.5 8v-6h8v6H4zm-2 4a1 1 0 001 1h10a1 1 0 100-2H3a1 1 0 00-1 1z"
            fill="currentColor"
        />
    </svg>
);
export default SvgCount;
